import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';
// import { NgxChartsModule } from '@swimlane/ngx-charts';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AvailabilityComponent } from './availability.component';
import { NgxEchartsModule } from 'ngx-echarts';

export function loadEcharts() { return import('echarts'); }

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        SharedModule,
        NgxEchartsModule.forRoot({ echarts: loadEcharts })
    ],
    declarations: [
        AvailabilityComponent
    ],
    providers: [],
    exports: [],
    bootstrap: []
})
export class AvailabilityModule {}